import {Injectable} from '@angular/core';
import Point from '@arcgis/core/geometry/Point';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import {ReplaySubject, Subject} from 'rxjs';
import MapView from '@arcgis/core/views/MapView';
import WebMap from '@arcgis/core/WebMap';
import Map from '@arcgis/core/Map';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';

@Injectable({providedIn: 'root'})
export class MapService {
  private _graphicsLayer;
  private _map: ReplaySubject<WebMap> = new ReplaySubject<WebMap>();
  private _view: ReplaySubject<MapView> = new ReplaySubject<MapView>();
  public currentLocation: Subject<any> = new Subject<any>();

  constructor() {
  }

  public getMap() {
    return this._map;
  }

  public getView() {
    return this._view
  }

  public getGraphicsLayer() {
    return this._graphicsLayer;
  }

  public setMap(map: WebMap) {
    this._map.next(map);
  }

  public setView(view: MapView) {
    this._view.next(view);
  }

  public setGraphicsLayer(graphicsLayer) {
    this._graphicsLayer = graphicsLayer;
  }

  public replaceGraphic(globalid, shape) {
    this._graphicsLayer.graphics.map((graphic) => {
      if (graphic.attributes !== undefined && graphic.attributes.globalid === globalid) {
        const geometry = new Point({x: shape.x, y: shape.y, spatialReference: {wkid: 3857}});
        graphic.setGeometry(geometry);
      }
    });
  }

  public setCurrentLocation(geometry) {
    this.currentLocation.next(geometry);
  }

  // public zoomToExtent(extent) {
  //   this.getV().subscribe((map) => {
  //     map.extent = extent;
  //   });
  // }

  getLayerFromMap(webmap: Map, url: string): FeatureLayer | MapImageLayer {
    const [u, i] = this.splitLayerIndexFromUrl(url);

    return webmap.allLayers.find(l => {
      if (l instanceof FeatureLayer) {
        return l.url?.startsWith(u) && l.layerId === parseInt(i, 10);
      }
      if (l instanceof MapImageLayer) {
        return l.url?.startsWith(u);
      }
      return false;
    }) as FeatureLayer | MapImageLayer;
    // todo: return featurelayer or map image layer object if not found in map?
  }

  splitLayerIndexFromUrl(url: string) {
    const re = /FeatureServer\/|MapServer\//;
    return url.split(re);
  }
}
